export const LEAD_STATUSES = ["New", "Contacted", "Qualified", "Appointment Booked", "Job Completed", "Lost"];

export const STATUS_STYLES = {
  New: "bg-blue-100 text-blue-800 border-blue-200",
  Contacted: "bg-sky-100 text-sky-800 border-sky-200",
  Qualified: "bg-violet-100 text-violet-800 border-violet-200",
  "Appointment Booked": "bg-amber-100 text-amber-800 border-amber-200",
  "Job Completed": "bg-emerald-100 text-emerald-800 border-emerald-200",
  Lost: "bg-slate-100 text-slate-600 border-slate-200",
};

export const SOURCE_OPTIONS = ["Manual", "Website Form", "Google", "Facebook", "Referral", "Phone Call", "Yelp", "Other"];
